export default __webpack_public_path__ + "static/media/banner-phone.1e2ff036.png";